/** Upload pipeline stage for a med-chron file on the Add Files surface. */
export enum MedChronFileStatus {
  UPLOADING = 'uploading',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  EXTRACTED = 'extracted',
  ERROR = 'error',
}
